import React, { useState, useEffect } from "react";
import "./management.css";


import HeadingContainer from "../heading-container/HeadingContainer";
import { Container, Grid, Box, Typography } from "@mui/material";

function Management() {
  const [managementList, setManagementList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/management`)
      .then(res => res.json())
      .then(data => {
        if (data && Array.isArray(data)) {
          setManagementList(data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching management", err);
        setLoading(false);
      });
  }, []);

  const displayList = managementList;

  return (
    <>
      <HeadingContainer title="Management Team" />
      <div className="management-wrapper">
        <Container maxWidth="lg">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            </div>
          ) : (
            <Grid container spacing={6}>
              {displayList.map((member, index) => {
                // Generate alternating fallback colors if API doesn't provide bgColor
                const isEven = index % 2 === 0;
                const defaultBg = isEven ? "" : "linear-gradient(135deg, #FF9A9E 0%, #FECFEF 100%)";
                const defaultDivider = isEven ? "" : "#FF9A9E";
                
                return (
                  <Grid item xs={12} md={6} key={member._id || index}>
                    <Box className="mgmt-card hover-scale">
                      <div className="mgmt-img-container">
                        <div className="mgmt-img-backdrop" style={{ background: member.bgColor || defaultBg }}></div>
                        {member.imageUrl ? (
                           <img src={member.imageUrl} alt={member.name} className="mgmt-img" />
                        ) : (
                           <div className="mgmt-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e2e8f0', color: '#94a3b8', fontSize: '3rem' }}>
                             👤
                           </div>
                        )}
                      </div>
                      <div className="mgmt-info">
                        <Typography variant="h5" className="mgmt-name">{member.name}</Typography>
                        <Typography variant="subtitle1" className="mgmt-role">{member.position}</Typography>
                        <Typography variant="subtitle2" className="mgmt-creds">{member.education}</Typography>
                        <hr className="mgmt-divider" style={{ borderColor: member.dividerColor || defaultDivider }} />
                        <Typography variant="body1" className="mgmt-bio" style={{ whiteSpace: 'pre-line' }}>
                          {member.description}
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          )}
        </Container>
      </div>
    </>
  );
}

export default Management;
